import { useIntl } from 'react-intl';

import { ILocale } from '@locale/index';

export const useAltaIntl = () => {
  const intl = useIntl();
  const formatMessage = (key: keyof ILocale): string => {
    return intl.formatMessage({ id: key as string });
  };
  return {
    intl,
    formatMessage,
  };
};
